<template>
  <div>
    <b-overlay variant="white" :show="overlay" blur="0" opacity=".75"
      rounded="sm">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>Mostrar</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>entradas</label>
            </b-col>

            <b-col cols="12" md="6">
              <div class="d-flex align-items-center justify-content-end">
                <!--              <b-form-input-->
                <!--                  v-model="searchQuery"-->
                <!--                  class="d-inline-block mr-1"-->
                <!--                  placeholder="Pesquisar pela descricao"-->
                <!--              />-->
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table ref="refPicItemListTable" class="position-relative" :items="fetchPicItem" responsive
          :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty
          empty-text="Nenhum registro encontrado" :sort-desc.sync="isSortDirDesc">

          <template #cell(actions)="data">
            <div>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="gradient-primary" class="btn-icon mr-1"
                @click="openEditModal(data.item)">
                <feather-icon icon="EyeIcon" />
              </b-button>
            </div>

          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{
                dataMeta.of
              }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="totalPicItem" :per-page="perPage" first-number
                last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <ModalAtt idModal="modal-att-pic-item" titleModal="Detalhes Item" v-model="dataPicItem" @cancel="resetFormData()" />

    <modal-confirmation v-model="isDeleteModal" id-modal="modal-delete-pic-item" title="Deletar  PicItem"
      btn-cancel-label="Cancelar" btn-ok-label="Sim, deletar" @ok="handleRemover(deletedCustomField)"
      @cancel="resetFormData()">
      <template #message>
        <div>
          <p>Tem certeza que deseja deletar essa PicItem?</p>
        </div>
      </template>
    </modal-confirmation>

  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import {
  BButton,
  BCard,
  BCardBody,
  BCardImg,
  BCardSubTitle,
  BCardText,
  BCardTitle,
  BCol,
  BRow,
  BListGroup,
  BListGroupItem,
  BTable,
  VBToggle,
  VBModal,
  BMedia,
  BLink,
  BAvatar,
  VBTooltip,
} from 'bootstrap-vue';
import { avatarText } from '@core/utils/filter';
import ModalConfirmation from '@/components/ModalConfirmation.vue';
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue';
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import ModalAtt from './ModalAtt.vue';
import useList from './useList';

export default {
  components: {
    ModalAtt,
    BAvatar,
    BLink,
    BMedia,
    ModalConfirmation,
    BButton,
    BCard,
    BCardBody,
    BCardImg,
    BCardSubTitle,
    BCardText,
    BCardTitle,
    BCol,
    BRow,
    AppCollapse,
    AppCollapseItem,
    BListGroup,
    BListGroupItem,
    BTable,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
  },
  props: {
    picidbusca: {
      type: Number,
      require: true,
    },
    tabprecoid: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      isDeleteModal: false,
      deletedCustomField: {
        tipopicitemid: null,
        tipopicitemdescricao: '',
        tipopiciteminformavalorbrutoliquido: '',
        tipopicitemtipocontrole: '',
      },
    };
  },
  mounted() {
    this.setIdPic();
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }).format(value);
    },
    handleRemover(body) {
      this.removerData(body);
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Sucesso',
          text: 'Pic Item deletado com sucesso',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });
      this.isDeleteModal = false;
    },
    openModalDeleteCustomField(data) {
      this.deletedCustomField = data;
      this.isDeleteModal = true;
    },
    openEditModal(data) {
      this.dataPicItem = data;
      this.$bvModal.show('modal-att-pic-item');
    },
    resetFormData() {
      this.dataPicItem = '';
      this.isDeleteModal = false;
    },
    setIdPic() {
      this.idpic = this.picidbusca;
    },
  },
  setup(props) {
    const customFields = ref([]);
    const dataPicItem = ref({
      tipopicitemid: null,
      tipopicitemdescricao: '',
      tipopiciteminformavalorbrutoliquido: '',
      tipopicitemtipocontrole: '',
    });

    // 'VARCHAR', 'INTEGER', 'TIMESTAMP', 'BOOLEAN', 'DATETIME', 'DATE', 'ENUM_OPTIONS', 'TEXT'
    const typeOptionsCustomFields = ref([
      { label: 'Texto', value: 'VARCHAR' },
      { label: 'Númerico', value: 'INTEGER' },
      { label: 'Monetário', value: 'DECIMAL' },
      { label: 'Data', value: 'DATE' },
      { label: 'Data e hora', value: 'DATETIME' },
      { label: 'Texto Longo', value: 'TEXT' },
    ]);
    const currentTab = ref(0);
    const spanderAll = ref(false);

    const headerCustomFields = [
      { key: 'id', label: '' },
      { key: 'label', label: 'Nome' },
      { key: 'quality_rules', label: 'Regras de qualidade' },
      { key: 'actions', label: 'Ações' },
    ];
    const customFieldsOptions = [
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
      {
        id: '1',
        label: 'Nome',
        type: 'text',
      },
    ];

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ];

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ];

    const {
      perPage,
      currentPage,
      totalPicItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      overlay,
      tableColumns,
      refPicItemListTable,
      fetchPicItem,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      create,
      Updated,
      idpic,
      removerData,
    } = useList();

    return {
      // Filter
      avatarText,
      planOptions,
      statusOptions,
      headerCustomFields,
      customFieldsOptions,
      spanderAll,
      currentTab,
      dataPicItem,
      idpic,
      overlay,
      typeOptionsCustomFields,
      customFields,
      resolveTypeFieldText,
      resolveTypeFieldIcon,
      resolveItemStatusVariant,
      resolverDefaultValues,
      perPage,
      currentPage,
      totalPicItem,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      fetchPicItem,
      tableColumns,
      refPicItemListTable,
      create,
      Updated,
      removerData,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.bg-header-collapse {
  background-color: #6c757d !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select';
</style>
